import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const ADD_LINKED_CONTACT_MUTATION = gql`
  mutation AddLinkedContactMutation($input: AddLinkedContactInput!) {
    addLinkedContact(input: $input)
  }
`;

const UNLINK_CONTACT_MUTATION = gql`
  mutation UnlinkContactMutation($input: UnlinkContactInput!) {
    unlinkContact(input: $input)
  }
`;

export default function useLinkedContactMutate() {
  const { mutate: addLinkedContactMutate } = useMutation(ADD_LINKED_CONTACT_MUTATION);
  const { mutate: unlinkContactMutate } = useMutation(UNLINK_CONTACT_MUTATION);

  async function linkContact(companyid, contactid) {
    try {
      const input = {
        companyid,
        contactid,
      };
      const { data } = await addLinkedContactMutate({ input });
      return data;
    } catch (error) {
      console.error('Error linking contact to company:', error);
      addAlert('Error linking contact to company', 'high', 4);
      throw error;
    }
  }

  async function linkCompany(companyid, linkedcompanyid) {
    try {
      const input = {
        companyid,
        linkedcompanyid,
      };
      const { data } = await addLinkedContactMutate({ input });
      return data;
    } catch (error) {
      console.error('Error linking company to company:', error);
      addAlert('Error linking company to company', 'high', 4);
      throw error;
    }
  }

  async function unlinkContact(companyid, contactid) {
    try {
      const input = {
        companyid,
        contactid,
      };
      const { data } = await unlinkContactMutate({ input });
      return data;
    } catch (error) {
      console.error('Error unlinking contact from company:', error);
      addAlert('Error unlinking contact from company', 'high', 4);
      throw error;
    }
  }

  async function unlinkCompany(companyid, linkedcompanyid) {
    try {
      const input = {
        companyid,
        linkedcompanyid,
      };
      const { data } = await unlinkContactMutate({ input });
      return data;
    } catch (error) {
      console.error('Error unlinking company from company:', error);
      addAlert('Error unlinking company from company', 'high', 4);
      throw error;
    }
  }

  return {
    linkContact,
    linkCompany,
    unlinkContact,
    unlinkCompany,
  };
}
